import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-searchinput', 'clear', 'Clear input');
Labels.set('ui-searchinput', 'search', 'Search');
